import {
  ascend,
  contains,
  descend,
  isEmpty,
  isNil,
  propOr,
  sortWith,
} from "ramda";

import type { IRole } from "types/user";
import type { IAppUser } from "types/user/app_user";

function userHasAnalytics(user: IAppUser | null): boolean {
  return userHasApp(user, "analytics");
}

function userHasPOS(user: IAppUser | null): boolean {
  return userHasApp(user, "breadcrumb");
}

function userHasInventory(user: IAppUser | null): boolean {
  return userHasApp(user, "inventory");
}

function userHasApp(user: IAppUser | null, app: string): boolean {
  // if we don't have a user we assume "they" don't have access to the application
  if (isNil(user) || isNil(user.applications) || isEmpty(user.applications)) {
    return false;
  }

  const { analytics, breadcrumb, inventory } = user.applications;

  switch (app) {
    case "analytics": {
      return !isNil(analytics) && !isEmpty(analytics);
    }
    case "breadcrumb": {
      return !isNil(breadcrumb) && !isEmpty(breadcrumb);
    }
    case "inventory": {
      return !isNil(inventory) && !isEmpty(inventory);
    }
    default: {
      return false; // would arrive here if the user had zero apps yet
    }
  }
}

function hasApp(appList: string[], app: string): boolean {
  return contains(app, appList);
}

function isUserPosOnly(user: { username: string | null }): boolean {
  return isNil(user) || isEmpty(user.username) || isNil(user.username);
}

const sortRoles = sortWith<IRole>([
  descend(propOr(0, "userCount")),
  ascend(propOr("", "name")),
]);

export {
  hasApp,
  isUserPosOnly,
  sortRoles,
  userHasAnalytics,
  userHasInventory,
  userHasPOS,
};
